import Radio from '@components/v2/form/Radio/Radio';
import { FormControl, FormHelperText, FormLabel, RadioGroup as MuiRadioGroup } from '@mui/material';
import { ReactNode, forwardRef } from 'react';

export interface RadioGroupOption {
  value: string;
  label: ReactNode;
  disabled?: boolean;
}

interface Props {
  name: string;
  value: string;
  options: RadioGroupOption[];
  label?: ReactNode;
  helperText?: ReactNode;
  error?: boolean;
  disabled?: boolean;
  required?: boolean;
  column?: boolean;
  size?: 'small' | 'medium';
  testId?: string;
  onChange: (value: string) => void;
}

const RadioGroup = forwardRef<HTMLDivElement, Props>(
  (
    {
      name,
      value,
      options,
      label,
      helperText,
      error,
      disabled,
      required,
      column,
      size = 'small',
      testId,
      onChange,
    },
    ref,
  ) => (
    <FormControl component="fieldset" error={error} disabled={disabled} fullWidth>
      {label && (
        <FormLabel component="legend" required={required} sx={{ typography: 'body2', mb: 0.5 }}>
          {label}
        </FormLabel>
      )}
      <MuiRadioGroup
        ref={ref}
        row={!column}
        name={name}
        value={value}
        test-id={testId}
        sx={(theme) => ({ gap: theme.spacing(column ? 1 : 2) })}
        onChange={(_, selected) => onChange(selected)}
      >
        {options.map((option) => (
          <Radio
            key={option.value}
            size={size}
            value={option.value}
            label={option.label}
            disabled={option.disabled}
            checked={value === option.value}
            sx={{ marginLeft: 0, marginRight: 0 }}
          />
        ))}
      </MuiRadioGroup>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  ),
);

RadioGroup.displayName = 'RadioGroup';
export type { Props as RadioGroupProps };
export default RadioGroup;
